import { MAIN_PURPLE } from "../../utils/constants/colorsConstants";

const VioletSunsetTablet = (props) => {
  const { navigateToWaitlist } = props;

  return (
    <div
      id="violet-sunset-body-tablet"
      style={{
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        gap: "3rem",
        width: "100%",
        height: "100%",
        padding: window.innerWidth > 550 ? "0 6rem" : "1rem 3rem",
        marginBottom: "2rem",
      }}
    >
      <div
        id="violet-sunset-text-and-logo"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          gap: window.innerWidth > 550 ? "4rem" : "2rem",
          width: "100%",
          height: "100%",
        }}
      >
        <img
          src="images/TiJUBU-Horizontal-Logo.png"
          alt="logo"
          id="TiJUBU-logo"
          style={{
            width: window.innerWidth > 450 ? "356px" : "250px",
            height: window.innerWidth > 450 ? "112px" : "79px",
          }}
        />

        <div
          id="violet-sunset-text"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "2rem",
            alignItems: "start",
          }}
        >
          <div
            id="violet-sunset-title-subtitle"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
            }}
          >
            <h1
              style={{
                fontSize: window.innerWidth > 450 ? "1.5rem" : "1rem",
                lineHeight: "1rem",
                color: MAIN_PURPLE,
                fontWeight: "bold",
              }}
            >
              violet is moving to TiJUBU
            </h1>
            <h2
              style={{
                fontSize: window.innerWidth > 450 ? "3rem" : "1.5rem",
                lineHeight: window.innerWidth > 450 ? "4rem" : "2rem",
                color: "black",
                fontWeight: "bolder",
              }}
            >
              Your well-being will soon <br /> be even more incredible.
            </h2>
          </div>
          <p
            style={{
              fontSize: "1rem",
              lineHeight: "1.75rem",
              color: "black",
              fontWeight: "lighter",
            }}
          >
            You’ve witnessed the spark to help you be well on violet.
            <br />
            <br />
            That power will continue in TiJUBU with deeper insights, bigger{" "}
            purpose, same you.
            <br />
            Your incredible journey of you becoming you.
          </p>

          <button
            type="button"
            style={{
              alignSelf: "center",
              width: "100%",
              backgroundColor: MAIN_PURPLE,
              color: "white",
              border: "none",
              padding: "1rem 1.5rem",
              borderRadius: "2rem",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
            onClick={navigateToWaitlist}
          >
            Join the waitlist
          </button>
        </div>
      </div>
    </div>
  );
};

export default VioletSunsetTablet;
